// Module
var code = `
<div ng-form="\$ctrl.form" novalidate>
  <div class="alert alert--danger" ng-if="\$ctrl.hasDuplicateRows">
    Sheet, Cell and Column must be unique
  </div>
    <div class="actions-header">
      <button type="button" class="btn btn-primary" ng-click="\$ctrl.addRow()">Add new record</button>
    </div>
    <table class="table table--last-column-to-right" ng-if="\$ctrl.rows">
      <thead class="sub-header">
        <tr>
          <th class="sheet">Sheet</th>
          <th class="cell-value">Cell</th>
          <th class="formula">Formula</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody class="tbody">
      <tr ng-repeat="reportMapping in \$ctrl.rows" ng-form="currentRow">
        <td title="'Sheet'" class="report-list-row sheet" ng-class="{ 'ng-invalid' : reportMapping.isUnique }">
          <input type="text"
                 ng-disabled="!reportMapping.editMode"
                 ng-model="reportMapping.sheet"
                 required>
          <validator condition="reportMapping.isUnique"></validator>
        </td>
        <td title="'Cell'" class="report-list-row cell-value">
          <input type="text"
                 ng-disabled="!reportMapping.editMode"
                 ng-model="reportMapping.cellValue"
                 ng-model-options="\$ctrl.cellColumnConfig"
                 pattern="[a-zA-Z]+:\\d+"
                 required>

        </td>
        <td title="'Formula'" class="report-list-row formula">
          <textarea
                 rows="3"
                 ng-disabled="!reportMapping.editMode"
                 ng-model="reportMapping.formula"
                 maxlength="4096"
                 required>
          </textarea>
        </td>
        <td class="table__actions table__actions--input-height">
          <button type="button" class="btn btn-primary"
                  ng-click="reportMapping.enableUpdate()"
                  ng-if="!reportMapping.editMode">Edit</button>
          <button type="button" class="btn btn-primary"
                  ng-click="\$ctrl.updateRow(reportMapping)"
                  ng-if="reportMapping.editMode">Update</button>
          <button type="button" class="btn btn-warning"
                  ng-click="reportMapping.revert()"
                  ng-if="reportMapping.editMode">Cancel</button>
          <button type="button" class="btn btn-info"
                  ng-click="\$ctrl.deleteRow(reportMapping)"
                  ng-if="!reportMapping.editMode">Delete</button>
          <button type="button" class="btn btn-success"
                  ng-click="\$ctrl.validateRow(reportMapping)"
                  ng-if="!reportMapping.editMode">Test</button>
        </td>
      </tr>
      </tbody>
    </table>
</div>

`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/dynamic-report/mapping/edit/dynamic-report-mapping-edit.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;